import React from 'react';



type Props = {
	children: React.ReactNode,
	/** We can force set default maximum width of wrapper */
	maxWidth: string | number,
	/** We can force set default width of wrapper */
	width: string | number,
};



const MobilePlansCaptionWrapper: React.FC<Props> = (props) => {
	const {
		children,
		maxWidth,
		width,
	} = props;

	return (
		<div
			className="mobile-plans-caption-wrapper"
			style={{
				maxWidth,
				width,
			}}
		>
			{children}
		</div>
	);
};



export default MobilePlansCaptionWrapper;
